<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="d-flex align-items-center mb-3 mt-3" style="gap:8px;">
        <b-button variant="secondary" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
        </b-button>
        <base-button
          v-if="puedeEscribir && (rol === 'admin' || rol === 'ventas inex')"
          :type="editMode ? 'danger' : 'warning'"
          @click="cancelEdit"
        >
          {{ editMode ? $t('cancelar') : $t('editar') }}
        </base-button>
      </div>

      <b-container style="max-width: 90%; margin: auto;">

        <b-card-header class="border-0">
          <h3 class="mb-0">{{ $t('informacion') }}</h3>
        </b-card-header>
        <b-form @submit.prevent="submitempresa">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombreEmpresa">
                <template v-slot:label>
                  {{ $t('nombre') }} <span v-if="editMode" class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="nombreEmpresa" v-model="empresa.nombre" required
                  :placeholder="$t('nombre_empresa')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="rutEmpresa">
                <template v-slot:label>
                  {{ $t('rut') }} <span v-if="editMode" class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="rutEmpresa" v-model="empresa.rut" required
                  :placeholder="$t('rut_empresa')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="nombreFantasia">
                <template v-slot:label>{{ $t('nombre_fantasia') }}</template>
                <b-form-input :disabled="!editMode" id="nombreFantasia" v-model="empresa.nombreFantasia"
                  maxlength="200" :placeholder="$t('nombre_fantasia')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="taxId">
                <template v-slot:label>{{ $t('tax_id') }}</template>
                <b-form-input :disabled="!editMode" id="taxId" v-model="empresa.taxId"
                  maxlength="30" :placeholder="$t('tax_id')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="direccion">
                <template v-slot:label>
                  {{ $t('direccion') }} <span v-if="editMode" class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="direccion" v-model="empresa.direccion"
                  :placeholder="$t('direccion')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <p class="p-login">{{ $t('pais') }} <span v-if="editMode" style="color:red">*</span></p>
              <el-select :disabled="!editMode" class="custom-input" v-model="empresa.idPais" @change="onChangePais"
                filterable clearable :placeholder="$t('seleccione')">
                <el-option v-for="item in opcionesPaises" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-col>
            <b-col md="4">
              <p class="p-login">{{ $t('region') }} <span v-if="editMode" style="color:red">*</span></p>
              <el-select class="custom-input" :disabled="!empresa.idPais || !editMode" @change="onChangeRegion"
                v-model="empresa.idRegion" filterable clearable :placeholder="$t('seleccione')">
                <el-option v-for="item in opcionesRegiones" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-col>
            <b-col md="4">
              <p class="p-login">{{ $t('comuna') }} <span v-if="editMode" style="color:red">*</span></p>
              <el-select class="custom-input" :disabled="!empresa.idRegion || !editMode" v-model="empresa.idComuna"
                filterable clearable :placeholder="$t('seleccione')">
                <el-option v-for="item in opcionesComunas" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="industria">
                <template v-slot:label>
                  {{ $t('industria') }}
                </template>
                <el-select
                  id="industria"
                  v-model="empresa.idIndustria"
                  :disabled="!editMode"
                  filterable
                  clearable
                  :placeholder="$t('industria')"
                >
                  <el-option
                    v-for="item in opcionesIndustrias"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="suscripcion">
                <template v-slot:label>
                  {{ $t('kam') }}
                </template>
                <el-select class="custom-input" :disabled="!editMode" v-model="empresa.idKam" filterable
                  clearable :placeholder="$t('seleccione')" value-key="value">
                  <el-option v-for="item in opcionesKAM" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="holding">
                <template v-slot:label>
                  Holding
                </template>
                <el-select class="custom-input" :disabled="!editMode" v-model="empresa.IdHolding" filterable
                  clearable :placeholder="$t('seleccione')" value-key="value">
                  <el-option v-for="item in opcionesHoldings" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="suscripcion">
                <template v-slot:label>
                  {{ $t('tipo_suscripcion') }}
                </template>
                <el-select class="custom-input" :disabled="!editMode" v-model="empresa.idSuscripcion" filterable
                  clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesSuscripciones" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="web">
                <template v-slot:label>
                  {{ $t('web') }}
                </template>
                <b-form-input id="web" :disabled="!editMode" v-model="empresa.web" :placeholder="$t('web')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="nombreContacto">
                <template v-slot:label>
                  {{ $t('nombre_contacto') }} <span v-if="editMode" class="text-danger">*</span>
                </template>
                <b-form-input
                  id="nombreContacto"
                  :disabled="!editMode"
                  v-model="empresa.nombreContacto"
                  :placeholder="$t('nombre_contacto')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="mailContacto">
                <template v-slot:label>
                  {{ $t('email_contacto') }} <span v-if="editMode" class="text-danger">*</span>
                </template>
                <b-form-input
                  id="mailContacto"
                  type="email"
                  :disabled="!editMode"
                  v-model="empresa.mailContacto"
                  :placeholder="$t('email_contacto')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mt-3" label-for="fonoContacto">
                <template v-slot:label>
                  {{ $t('fono_contacto') }} <span v-if="editMode" class="text-danger">*</span>
                </template>
                <b-form-input
                  id="fonoContacto"
                  :disabled="!editMode"
                  v-model="empresa.fonoContacto"
                  :placeholder="$t('fono_contacto')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <h4 class="mt-4">{{ $t('intereses') }}</h4>
          <b-row v-if="editMode">
            <b-col md="4">
              <b-form-group :label="$t('tipos_equipos')">
                <el-select class="custom-input" :disabled="!editMode" v-model="interesesForm.tipoEquipos" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesEquipos" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('marcas')">
                <el-select v-model="interesesForm.marcas" :disabled="!editMode" :options="opcionesMarcas" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesMarcas" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('componentes')">
                <el-select v-model="interesesForm.componentes" :disabled="!editMode" :options="opcionesComponentes"
                  multiple filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesComponentes" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('estado_nuevo_usado')">
                <el-select v-model="interesesForm.estados" :disabled="!editMode" :options="opcionesEstado" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesEstado" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('procesos')">
                <el-select v-model="interesesForm.procesos" :disabled="!editMode" :options="opcionesProcesos" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesProcesos" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col v-if="empresaIntereses && empresaIntereses.length <= 0" class="mb-4" md="4">
              <p class="p-login">{{ $t('no_hay_intereses') }}</p>
            </b-col>
            <b-col v-else v-for="(items, tipo) in agrupadosPorTipo" :key="tipo" md="4">
              <p class="p-login font-weight-bold">{{ tipo }}</p>
              <b-badge v-for="interes in items" :key="interes.id" variant="success"
                class="mb-2 text-uppercase small px-2 py-1 rounded-pill">
                {{ interes.nombre }}
              </b-badge>
            </b-col>
          </b-row>
          <b-button v-if="editMode" type="submit" variant="primary">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';
import zonaService from '@/api/zonaService';
import empresaService from '@/api/empresaService';
import interesService from '@/api/interesService';
import userService from '@/api/userService';
import holdingService from '@/api/holdingService';
import utilsService from '@/api/utilsService';

export default {
  name: 'empresa-detalle',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      empresa: {},
      opcionesComunas: [],
      opcionesPaises: [],
      opcionesRegiones: [],
      opcionesSuscripciones: [],
      editMode: false,
      opcionesEquipos: [],
      opcionesMarcas: [],
      opcionesEstado: [],
      opcionesProcesos: [],
      opcionesComponentes: [],
      opcionesKAM: [],
      opcionesHoldings: [],
      opcionesIndustrias: [],
      intereses: [],
      empresaIntereses: [],
      interesesForm: {
        componentes: [],
        tipoEquipos: [],
        marcas: [],
        procesos: [],
        estados: [],
      },
    };
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.initData(id);
  },
  computed: {
    agrupadosPorTipo() {
      if (this.empresaIntereses)
        return this.empresaIntereses.reduce((acc, interes) => {
          if (!acc[interes.tipoInteres]) {
            acc[interes.tipoInteres] = [];
          }
          acc[interes.tipoInteres].push(interes);
          return acc;
        }, {});
    },
    rol() {
      return utilsService.getRol();
    }
  },
  methods: {
    ordenarOpciones(opciones) {
      return Array.isArray(opciones)
        ? [...opciones].sort((a, b) =>
            String((a && a.text) || '').localeCompare(String((b && b.text) || ''), 'es', { sensitivity: 'base' })
          )
        : [];
    },
    async initData(id) {
      this.lang = localStorage.getItem('language');
      // Cargar datos en paralelo
      const [empresa, intereses, kam, holdings, paises, suscripciones] = await Promise.all([
        empresaService.get(id),
        empresaService.getIntereses(id, this.lang),
        userService.getKamOptions(),
        holdingService.getActivos(),
        zonaService.getPaisesOptions(),
        empresaService.getSuscripcionesOptions(),
      ]);
      
      const idHolding =
        empresa && empresa.IdHolding !== undefined && empresa.IdHolding !== null
          ? empresa.IdHolding
          : empresa && empresa.idHolding !== undefined && empresa.idHolding !== null
            ? empresa.idHolding
            : null;

      this.empresa = {
        ...empresa,
        IdHolding: idHolding,
      };
      this.empresaIntereses = intereses;
      this.opcionesKAM = this.ordenarOpciones(kam);
      this.opcionesHoldings = this.ordenarOpciones(Array.isArray(holdings)
        ? holdings.map((item) => ({
            value:
              item && item.value !== undefined && item.value !== null
                ? item.value
                : item && item.id !== undefined && item.id !== null
                  ? item.id
                  : item && item.Id !== undefined && item.Id !== null
                    ? item.Id
                    : item && item.idHolding !== undefined && item.idHolding !== null
                      ? item.idHolding
                      : item && item.IdHolding !== undefined && item.IdHolding !== null
                        ? item.IdHolding
                        : null,
            text:
              item && item.text !== undefined && item.text !== null
                ? item.text
                : item && item.nombre !== undefined && item.nombre !== null
                  ? item.nombre
                  : item && item.name !== undefined && item.name !== null
                    ? item.name
                    : item && item.descripcion !== undefined && item.descripcion !== null
                      ? item.descripcion
                      : String(item && item.value !== undefined ? item.value : item && item.id !== undefined ? item.id : ''),
          }))
        : []);
      this.opcionesPaises = this.ordenarOpciones(paises);
      this.opcionesSuscripciones = this.ordenarOpciones(suscripciones);

      if (this.empresa.idPais) {
        zonaService.getRegionesOptions(this.empresa.idPais).then((data) => (this.opcionesRegiones = this.ordenarOpciones(data)));
      }

      if (this.empresa.idRegion) {
        zonaService.getComunasOptions(this.empresa.idRegion).then((data) => (this.opcionesComunas = this.ordenarOpciones(data)));
      }

      interesService.getInteresOptions().then((data) => {
        this.intereses = data;
        this.opcionesEstado = this.ordenarOpciones(data.find((t) => t.tipo == 'estados').options);
        this.opcionesMarcas = this.ordenarOpciones(data.find((t) => t.tipo == 'marcas').options);
        this.opcionesEquipos = this.ordenarOpciones(data.find((t) => t.tipo == 'tipoequipos').options);
        this.opcionesComponentes = this.ordenarOpciones(data.find((t) => t.tipo == 'componentes').options);
        this.opcionesProcesos = this.ordenarOpciones(data.find((t) => t.tipo == 'procesos').options);
        this.opcionesIndustrias = this.ordenarOpciones(data.find((t) => t.tipo == 'industrias').options);

        this.interesesForm.estados = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'estados')
          .map((i) => i.id);
        this.interesesForm.marcas = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'marcas')
          .map((i) => i.id);
        this.interesesForm.tipoEquipos = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase().replace(' ', '') === 'tipoequipos')
          .map((i) => i.id);
        this.interesesForm.componentes = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'componentes')
          .map((i) => i.id);
        this.interesesForm.procesos = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'procesos')
          .map((i) => i.id);
      });
    },
    async cancelEdit() {
      if (!this.puedeEscribir) return;
      if (this.editMode) {
        const id = this.$route.params.id;
        await this.initData(id);
      }
      this.editMode = !this.editMode;
    },
    async onChangePais() {
      this.empresa.idRegion = null;
      this.opcionesRegiones = this.ordenarOpciones(await zonaService.getRegionesOptions(this.empresa.idPais));
    },
    async onChangeRegion() {
      this.empresa.idComuna = null;
      this.opcionesComunas = this.ordenarOpciones(await zonaService.getComunasOptions(this.empresa.idRegion));
    },
    async submitempresa() {
      if (!this.puedeEscribir) return;
      if (!this.empresa.idPais || !this.empresa.idRegion || !this.empresa.idComuna) {
        this.$toast.error(this.$t('verificar_datos_pais_region'), {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true,
        });
        return;
      }

      this.empresa.estados = this.interesesForm.estados;
      this.empresa.marcas = this.interesesForm.marcas;
      this.empresa.tipoEquipos = this.interesesForm.tipoEquipos;
      this.empresa.componentes = this.interesesForm.componentes;
      this.empresa.procesos = this.interesesForm.procesos;

      Swal.fire({
        title: this.$t('guardar_cambios_pregunta'),
        text: this.$t('verificar_datos_pregunta'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('actualizar'),
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                      <div>
                        <h3 style="color: #006393;">Loading...</h3>
                      </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            const id = this.$route.params.id;
            const response = await empresaService.update(this.empresa, id);
            if (!response) {
              Swal.fire({ icon: 'error', title: 'Oops...', text: 'Error' });
              return;
            }
            Swal.fire({
              title: this.$t('cambios_guardados_correctamente'),
              icon: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            this.editMode = false;

            this.empresa = await empresaService.get(id);
            this.empresaIntereses = await empresaService.getIntereses(id, this.lang);
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: error.message,
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
  },
};
</script>

<style scoped>
.p-login {
  margin-bottom: 0;
}

.el-select {
  display: block;
}
</style>
